export type UnitType =
  | "mg"
  | "g"
  | "kg"
  | "ton"
  | "mm"
  | "cm"
  | "m"
  | "km"
  | "ml"
  | "l"
  | "piece";

export const UNITS: { value: UnitType; label: string }[] = [
  { value: "mg", label: "Milligram" },
  { value: "g", label: "Gram" },
  { value: "kg", label: "Kilogram" },
  { value: "ml", label: "Milliliter" },
  { value: "l", label: "Liter" },
  { value: "mm", label: "Millimeter" },
  { value: "cm", label: "Centimeter" },
  { value: "m", label: "Meter" },
  { value: "piece", label: "Piece" },
];

export interface IWarehouseRawMaterial {
  _id: string;
  name: string;
  sku: string;
  hsn?: string;
  type: string;
  quantity: { [warehouseId: string]: number }; // Quantity per warehouse
  unit: UnitType;
  usageType?: string;
  unitType: string;
  gst?: number;
  approxDeliveryDays: number;
  requireSerialNumber?: boolean;
  totalPrice?: number;
  rate?: number;
  bomId?: string;
}

// Interface for API response in StoreInwardTab
export interface IWarehouseRawMaterialResponse {
  id: string;
  name: string;
  sku: string;
  type: string;
  quantity: number;
  unit: string;
  gst?: number;
  approxDeliveryDays: number;
  lastSevenDaysAverage: number;
  daysStockLeft: number;
}
